import axios from 'axios';
import React from 'react';
import { useState } from 'react';
import { encode as base64_encode } from 'base-64';
import { sha256 } from 'js-sha256';

const Phonepe = () => {

    const apiEndpoint = 'https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay';

    const [amount, setAmount] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');

    const handleSubmit = async () => {
        if (!amount) {
            alert('Please enter an amount.');
            return;
        }

        if (!mobileNumber) {
            alert('Please enter a mobile number.');
            return;
        }

        const originalPayload = {
            "merchantId": "TASKDEONLINE",
            "merchantTransactionId": "MT7850590068188104",
            "merchantUserId": "MUID123",
            "amount": parseInt(amount),
            "redirectUrl": "https://webhook.site/redirect-url",
            "redirectMode": "POST",
            "callbackUrl": "https://webhook.site/callback-url",
            "mobileNumber": hashMobileNumber(mobileNumber),
            "paymentInstrument": {
                "type": "PAY_PAGE"
            }
        };

        const base64EncodedPayload = base64_encode(JSON.stringify(originalPayload));
        const saltKey = "66e39cc1-b315-4a85-9490-90209ce9e854";
        const saltIndex = "1";
        const additionalText = "###";
        const sha256Hash = sha256(base64EncodedPayload + "/pg/v1/pay" + saltKey);
        // const finalComputation = sha256Hash + additionalText + "1";
        const xVerifyHeaderValue = sha256Hash + additionalText + saltIndex;

        try {
            const response = await axios.post(apiEndpoint, { request: base64EncodedPayload }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-VERIFY': xVerifyHeaderValue,
                },
            });


        } catch (error) {
            console.error(error);
        }
    };

    const hashMobileNumber = (number) => {
        const hashedNumber = sha256(number);
        return hashedNumber;
    };

    return (
        <div>
            <h5>Pay with PhonePe</h5>
            <input
                type="number"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />
            <input
                type="text"
                placeholder="Enter mobile number"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
            />
            <button onClick={handleSubmit}>Pay Now</button>
        </div>
    )
}

export default Phonepe;